import { Address } from '../../utils/types'
import { Token } from '../token/token'

export interface Pool {
  address: Address
  tokens: Token[]
}

type PoolName = {
  name: string
  // max 11 chars !!!!
  symbol: string
}
export const poolNames: { [key: string]: PoolName } = {
  '0x7f5f7411c2c7ec60e2db946abbe7dc354254870b': {
    name: '3-crypto-2022',
    symbol: 'SWAAP-PT-0',
  },
}

export function getPoolName(address: string) {
  if (poolNames[address]) {
    return poolNames[address].name
  } else {
    return address
  }
}

export function getPoolSymbol(address: string) {
  if (poolNames[address]) {
    return poolNames[address].symbol
  } else {
    return 'SwaapLP'
  }
}

export function poolContainsToken(pool: Pool, token: Token): boolean {
  return pool.tokens.map(t => t.address).includes(token.address)
}

export function getPoolToken(pool: Pool) {
  const poolToken: Token = {
    name: getPoolName(pool.address),
    address: pool.address,
    symbol: getPoolSymbol(pool.address),
    decimals: 18,
  }
  return poolToken
}

export function listTokens(pool: Pool): string[] {
  return pool.tokens.map(t => t.symbol)
}
